import { atom } from 'jotai';
import { AppRoute } from 'types';

// Atom to store the protected routes
export const protectedRouteListAtom = atom<AppRoute[]>([]);
protectedRouteListAtom.debugLabel = 'protectedRoutesAtom';
